function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import dataplex_service from '@/apps/data-platform/services/data_quality/dataplex_service';
export default {
  props: {
    rule: {
      type: Object,
      required: true
    },
    view: {
      type: Boolean,
      required: true
    },
    edit: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      expectation: {},
      dimension: {},
      expectations: [],
      dimensions: [],
      statistic_values: [{
        value: 'STATISTIC_UNDEFINED',
        text: 'No Definido'
      }, {
        value: 'MEAN',
        text: 'Media'
      }, {
        value: 'MIN',
        text: 'Mínimo'
      }, {
        value: 'MAX',
        text: 'Máximo'
      }]
    };
  },
  computed: _objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'orgs', 'isDomainItc', 'dataplex_dimensions', 'dataplex_expectations'])),
  created: function created() {
    if (this.dataplex_dimensions && this.dataplex_dimensions.length > 0) {
      this.dimensions = this.dataplex_dimensions;
    } else {
      this.getDimensions();
    }
    if (this.dataplex_expectations && this.dataplex_expectations.length > 0) {
      this.expectations = this.dataplex_expectations;
      this.checkExpectation();
    } else {
      this.getExpectations();
    }
  },
  methods: {
    getDimensions: function getDimensions() {
      var _this = this;
      dataplex_service.getDimensions({}).then(function (response) {
        _this.dimensions = response.data;
        _this.$store.commit('data-platform/setDataplexDimensions', _this.dimensions);
      });
    },
    getExpectations: function getExpectations() {
      var _this2 = this;
      dataplex_service.getExpectations({}).then(function (response) {
        _this2.expectations = response.data;
        _this2.$store.commit('data-platform/setDataplexExpectations', _this2.expectations);
        _this2.checkExpectation();
      });
    },
    onValidate: function onValidate() {
      return this.$refs["form_rule"].validate();
    },
    checkExpectation: function checkExpectation() {
      var _this3 = this;
      if (this.rule.expectation) {
        var item = this.expectations.find(function (x) {
          return x.value == _this3.rule.expectation;
        });
        if (item) {
          this.expectation = item;
          this.rule.expectation_name = item.text;
        }
      }
    },
    onSelectValidation: function onSelectValidation(event) {
      var item = this.expectations.find(function (x) {
        return x.value == event;
      });
      if (item) {
        this.expectation = item;
        this.rule.expectation_name = item.text;
      }
    },
    onSelectDimension: function onSelectDimension(event) {
      var item = this.dimensions.find(function (x) {
        return x.value == event;
      });
      if (item) {
        this.dimension = item;
        this.rule.dimension_name = item.text;
      }
    }
  }
};